import { render, staticRenderFns } from "./WaterMarks.vue?vue&type=template&id=bbdb6d4c&"
import script from "./WaterMarks.vue?vue&type=script&lang=js&"
export * from "./WaterMarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports